// extracted by mini-css-extract-plugin
export default {"addCustomerButton":"AddOrder_addCustomerButton__004S0","field":"AddOrder_field__-yxYE","fieldGroup":"AddOrder_fieldGroup__ua37t","formAddSellitem":"AddOrder_formAddSellitem__QQ8HD"};